const BASE = process.env.REACT_APP_API_URL || "/api";

function token() { return localStorage.getItem("hp_token"); }

async function request(path, { method="GET", body, isFormData }={}) {
  const headers = {};
  if (token()) headers["Authorization"] = `Bearer ${token()}`;
  if (!isFormData) headers["Content-Type"] = "application/json";
  const res  = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: isFormData ? body : body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(()=>({}));
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

export const api = {
  // Campaigns
  getCampaigns:   (p={}) => request(`/campaigns?${new URLSearchParams(p)}`),
  getCategories:  ()     => request("/campaigns/meta/categories"),
  createCampaign: (fd)   => request("/campaigns",   { method:"POST", body:fd, isFormData:true }),
  updateCampaign: (id,fd)=> request(`/campaigns/${id}`, { method:"PUT",  body:fd, isFormData:true }),
  deleteCampaign: (id)   => request(`/campaigns/${id}`, { method:"DELETE" }),

  // Episodes
  getEpisodes:    (p={}) => request(`/episodes?${new URLSearchParams(p)}`),
  getTopics:      ()     => request("/episodes/meta/topics"),
  createEpisode:  (fd)   => request("/episodes",    { method:"POST", body:fd, isFormData:true }),
  updateEpisode:  (id,fd)=> request(`/episodes/${id}`,  { method:"PUT",  body:fd, isFormData:true }),
  deleteEpisode:  (id)   => request(`/episodes/${id}`,  { method:"DELETE" }),

  // Team
  getTeam:        ()     => request("/team"),
  createTeamMember:(fd)  => request("/team",        { method:"POST", body:fd, isFormData:true }),
  updateTeamMember:(id,fd)=>request(`/team/${id}`,  { method:"PUT",  body:fd, isFormData:true }),
  deleteTeamMember:(id)  => request(`/team/${id}`,  { method:"DELETE" }),

  // Testimonials
  getTestimonials:(p={}) => request(`/testimonials?${new URLSearchParams(p)}`),
  createTestimonial:(fd) => request("/testimonials",{ method:"POST", body:fd, isFormData:true }),
  updateTestimonial:(id,fd)=>request(`/testimonials/${id}`,{ method:"PUT", body:fd, isFormData:true }),
  deleteTestimonial:(id) => request(`/testimonials/${id}`,{ method:"DELETE" }),

  // Clients
  getClients:     (p={}) => request(`/clients?${new URLSearchParams(p)}`),
  createClient:   (fd)   => request("/clients",     { method:"POST", body:fd, isFormData:true }),
  updateClient:   (id,fd)=> request(`/clients/${id}`,   { method:"PUT",  body:fd, isFormData:true }),
  deleteClient:   (id)   => request(`/clients/${id}`,   { method:"DELETE" }),

  // Articles
  getArticles:    (p={}) => request(`/articles?${new URLSearchParams(p)}`),
  getArticle:     (slug) => request(`/articles/${slug}`),
  getArticleCats: ()     => request("/articles/meta/categories"),
  createArticle:  (fd)   => request("/articles",    { method:"POST", body:fd, isFormData:true }),
  updateArticle:  (id,fd)=> request(`/articles/${id}`,  { method:"PUT",  body:fd, isFormData:true }),
  deleteArticle:  (id)   => request(`/articles/${id}`,  { method:"DELETE" }),

  // Newsletter
  subscribe:           (data) => request("/newsletter/subscribe",   { method:"POST", body:data }),
  unsubscribe:         (data) => request("/newsletter/unsubscribe", { method:"POST", body:data }),
  sendNewsletterBlast: (data) => request("/newsletter/notify",      { method:"POST", body: data }),

  // Contact
  submitContact:  (data) => request("/contact",     { method:"POST", body:data }),
  getContacts:    ()     => request("/contact"),
  updateContactStatus:(id,status)=>request(`/contact/${id}/status`,{method:"PATCH",body:{status}}),

  // Settings
  getSettings:    ()     => request("/settings"),
  getSettingsFull:()     => request("/settings/full"),
  updateSettings: (data) => request("/settings",    { method:"PUT",  body:data }),

  // Auth
  login:          (u,p)  => request("/auth/login",  { method:"POST", body:{username:u,password:p} }),
  me:             ()     => request("/auth/me"),
  changePassword: (cur,nw)=>request("/auth/change-password",{method:"POST",body:{currentPassword:cur,newPassword:nw}}),

  // Admin
  getStats:       ()     => request("/admin/stats"),
  adminAll:       (res)  => request(`/admin/${res}`),
  getAuditLogs:   (p={}) => request(`/admin/audit-logs?${new URLSearchParams(p)}`),

  // User management (super_admin only)
  getUsers:          ()        => request("/users"),
  getPermissionsList:()        => request("/users/permissions"),
  createUser:        (data)    => request("/users",         { method:"POST",   body:data }),
  updateUser:        (id,data) => request(`/users/${id}`,   { method:"PUT",    body:data }),
  toggleUser:        (id)      => request(`/users/${id}/toggle`, { method:"PATCH" }),
  deleteUser:        (id)      => request(`/users/${id}`,   { method:"DELETE" }),

  // Services
  getServices:    ()      => request("/services"),
  createService:  (data)  => request("/services",     { method: "POST",   body: data }),
  updateService:  (id, data) => request(`/services/${id}`, { method: "PUT", body: data }),
  deleteService:  (id)    => request(`/services/${id}`, { method: "DELETE" }),
};
